import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { announcement_template } from "../components/templates/announcement_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class announcement extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected announcement: announcement_template;

    protected getModuleName(){
        return "announcement";
    }

    buildContent() : Array<Element>{

        this.announcement = new announcement_template( "announcementPage", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Announcement");

        return [ this.announcement.build()];
    }

    public fillPage() : void{

    }
}



// WEBPACK FOOTER //
// ./js/modules/announcement.ts